import { useNavigate } from 'react-router-dom';
export function useNavTo() {
  var navigate = useNavigate();
  return function (navItem, parentNavItems) {
    if (navItem.onClick) {
      navItem.onClick(navItem, parentNavItems);
    } else if (navItem.route) {
      navigate(navItem.route);
    } else if (navItem.url) {
      window.open(navItem.url, '_blank');
    } else {
      console.error('[useNavTo] navItem has no onClick, route nor url', navItem);
    }
  };
}